import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { ConverterReaderProtocolEnum } from '@zaoblako/shared/modules/pacs/enums/converter-reader-protocol.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link ConverterReaderProtocolEnum} enumeration values */
export const ConverterReaderProtocolEnumI18n: EnumI18nInterface<ConverterReaderProtocolEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [ConverterReaderProtocolEnum.TEST_MOCK_READER]: 'Тестовые карты',
    [ConverterReaderProtocolEnum.I_BUTTION]: 'Карты "iButton"',
    [ConverterReaderProtocolEnum.WIEGAND_26]: 'Карты "Wiegand 26"',
  },
  [I18nLocalesEnum.EN_US]: {
    [ConverterReaderProtocolEnum.TEST_MOCK_READER]: 'Test cards',
    [ConverterReaderProtocolEnum.I_BUTTION]: '"iButton" cards',
    [ConverterReaderProtocolEnum.WIEGAND_26]: '"Wiegand 26" cards',
  },
};
